import Link from 'next/link'

import { Text } from '@wartek-id/text'

import { getSession } from 'utils/auth'

const RoundedIcon = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex items-center justify-center w-8 h-8 rounded-full border">
      {children}
    </div>
  )
}

const NotEligible = () => {
  const session = getSession()
  const userEmail = session?.user?.email
  const userId = session?.user?.id

  return (
    <div
      className="p-4 bg-white min-h-full"
      data-testid="ppg-daljab-not-eligible"
    >
      <div className="bg-surface-subdued py-4 text-center rounded-md mb-4">
        <Text variant="heading-md">{userEmail}</Text>
        <Text variant="helper" className="mt-2">
          userID: {userId}
        </Text>
      </div>
      <Text variant="heading-lg" className="mb-8">
        Maaf, akun Anda belum termasuk dalam piloting PPG bagi Guru Tertentu
      </Text>
      <div className="mt-4">
        <div className="flex">
          <div className="mr-4">
            <RoundedIcon>
              <Text>A</Text>
            </RoundedIcon>
          </div>
          <div>
            <Text className="mb-1">
              <b>Lakukan pengecekan NIK</b> untuk pastikan email belajar.id lain
              yang mungkin terdaftar di Sertifikasi Pendidik
            </Text>
            <Link href="/checking" legacyBehavior>
              <a className="mt-2 text-blue-500 font-semibold">
                Klik untuk cek NIK
              </a>
            </Link>
          </div>
        </div>
        <hr className="my-4" />
        <div className="flex">
          <div className="mr-4">
            <RoundedIcon>
              <Text>B</Text>
            </RoundedIcon>
          </div>
          <div>
            <Text className="mb-1">
              Piloting PPG bagi Guru Tertentu bertujuan untuk memastikan
              pelaksanaan pembelajaran berjalan baik sebelum diterapkan secara
              masif
            </Text>
          </div>
        </div>
        <hr className="my-4" />
        <div className="flex">
          <div className="mr-4">
            <RoundedIcon>
              <Text>C</Text>
            </RoundedIcon>
          </div>
          <div>
            <Text className="mb-1">
              Jika Anda merupakan peserta piloting, pastikan telah melakukan
              konfirmasi dan lapor diri pada SIMPKB Anda. Anda dapat mulai
              belajar 12 jam setelah Anda melakukan konfirmasi diri
            </Text>
          </div>
        </div>
        <hr className="my-4" />
      </div>
    </div>
  )
}

export default NotEligible
